module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity2.3a1ddac5.jpg";